// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"97e4c45e","239":"1c26bf20","453":"d8145732","455":"e538aec0"}[chunkId] + ".chunk.js";
};